import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

export function flatPickers(){

    document.querySelectorAll<HTMLInputElement>(".flatpickr").forEach((el) => {
        setupDateMask(el);

        flatpickr(el, {
            dateFormat: "d.m.Y",
            allowInput: true,
            locale: Russian,
            disableMobile: "true",
        });
    });
}

function setupDateMask(input: HTMLInputElement) {
    input.addEventListener("input", () => {
        let value = input.value.replace(/\D/g, ""); // оставляем только цифры
        if (value.length > 8) value = value.slice(0, 8);

        // вставляем точки: 2 -> 2., 4 -> 2 цифры + точка + 2 цифры, 8 -> дата полностью
        if (value.length > 4) {
            value = value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4);
        } else if (value.length > 2) {
            value = value.slice(0, 2) + "." + value.slice(2);
        }

        input.value = value;
    });
}